import { graphql } from "@acto/gql";
import type { CreateWorkflowInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";
import { useMutation } from "urql";

const CreateWorkflowMutation = graphql(`
  mutation CreateWorkflow($input: CreateWorkflowInput!) {
    createWorkflow(input: $input) {
      id
      name
      isActive
    }
  }
`);

export function useCreateWorkflow() {
  const [result, createWorkflowMutation] = useMutation(CreateWorkflowMutation);
  const [error, setError] = useState<Error | null>(null);

  const createWorkflow = useCallback(
    async (input: CreateWorkflowInput) => {
      setError(null);

      try {
        const response = await createWorkflowMutation({ input });
        if (response.error) {
          throw response.error;
        }

        return response.data?.createWorkflow ?? null;
      } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error("Failed to create workflow");
        setError(error);

        console.error("unable to create workflow", error);

        return null;
      }
    },
    [createWorkflowMutation],
  );

  const reset = useCallback(() => setError(null), []);

  return { createWorkflow, isPending: result.fetching, error, reset };
}
